import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login");
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const { data } = await api.get("/auth/emergent/session", {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data.user);
        // Clear hash
        window.history.replaceState({}, "", "/");
        nav(data.user.role === "supplier" ? "/supplier" : data.user.role === "admin" ? "/admin" : "/customer");
      } catch (e) {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <Loader2 className="animate-spin text-haul-yellow" size={40} />
      <div className="font-mono uppercase text-xs tracking-widest text-neutral-400">Authenticating…</div>
    </div>
  );
}
